import { getEquipmentDocs } from './wizardHelpers';
// İSG eksiklik raporu için firma/personel/ekipman eksikliklerini toplar
import { COMPANY_DOCS } from '../../companies/constants';
import { EMPLOYEE_DOCS } from '../../employees/constants';
import { calculateOverallStatus } from '../../../lib/helpers';

export const buildDeficiencyReport = ({ selectedCompany, selectedEmployees, selectedEquipment, formData, equipmentSubtypes = [] }) => {
  const docKeys = EMPLOYEE_DOCS.map(d => d.key);
  
  // Firma eksikliklerini topla
  const companyDeficiencies = [];
  COMPANY_DOCS.forEach(doc => {
    const status = selectedCompany?.documents?.[doc.key];
    const note = selectedCompany?.documents?.[`${doc.key}_note`];
    if (status === 'eksik') {
      companyDeficiencies.push({ document: doc.label, doc_key: doc.key, note: note || 'Belge eksik' });
    }
  });
  
  // Personel eksikliklerini topla
  const employeeDeficiencies = [];
  const approvedEmployeeList = [];
  
  // Talep bitiş tarihini al
  const permitEndDate = formData.end_date ? formData.end_date.slice(0, 10) : null;
  
  selectedEmployees.forEach(emp => {
    const overall = calculateOverallStatus(emp.documents, docKeys);
    const deficiencies = [];
    let hasExpiringDocs = false;
    
    // Her belgeyi kontrol et
    EMPLOYEE_DOCS.forEach(doc => {
      const status = emp.documents?.[doc.key];
      const note = emp.documents?.[`${doc.key}_note`];
      
      // Eksik veya süresi dolmuş belgeler
      if (status === 'eksik' || status === 'suresi_doldu') {
        deficiencies.push({ 
          document: doc.label, doc_key: doc.key,
          note: note || (status === 'suresi_doldu' ? 'Belge süresi dolmuş' : 'Belge eksik')
        });
      }
      // Talep aralığında süresi dolacak belgeler (hasValidity: true olanlar)
      else if (status === 'onay' && doc.hasValidity && permitEndDate) {
        // _validity veya _date alanını kontrol et (MYK için her ikisi de olabilir)
        let validityDate = emp.documents?.[`${doc.key}_validity`];
        if (!validityDate && doc.key === 'mesleki_yeterlilik') {
          validityDate = emp.documents?.[`${doc.key}_date`];
        }
        if (validityDate) {
          try {
            const docExpiry = String(validityDate).slice(0, 10);
            if (docExpiry < permitEndDate) {
              hasExpiringDocs = true;
              const formattedDate = new Date(validityDate).toLocaleDateString('tr-TR');
              deficiencies.push({ 
                document: doc.label, doc_key: doc.key,
                note: `Talep tarih aralığında bu belgenin süresi dolmaktadır. Geçerlilik: ${formattedDate}`
              });
            }
          } catch (e) {
            // Tarih parse hatası - yoksay
          }
        }
      }
    });
    
    // Eksikliği veya süresi dolacak belgesi olan personeller
    if (deficiencies.length > 0) {
      employeeDeficiencies.push({
        id: emp.id,
        name: `${emp.name} ${emp.surname}`,
        position: emp.position || '',
        tc_kimlik_no: emp.tc_kimlik_no || '',
        deficiencies: deficiencies
      });
    } 
    // Tüm belgeleri onaylı ve süresi dolmayacak personeller
    else if (overall.status === 'onay') {
      approvedEmployeeList.push({
        name: `${emp.name} ${emp.surname}`,
        position: emp.position || '',
        tc_kimlik_no: emp.tc_kimlik_no || ''
      });
    }
  });
  
  // Ekipman eksikliklerini topla
  const equipmentDeficiencies = [];
  const approvedEquipmentList = [];
  const kindOf = (eq) => equipmentSubtypes.find(st => st.subtype_key === (eq.equipment_subtype || eq.subtype))?.subtype_label || '';
  selectedEquipment.forEach(eq => {
    const docs = eq.documents || {};
    const isVehicle = eq.equipment_type === 'arac';
    const eqDefs = getEquipmentDocs(eq.equipment_type).filter(d => !d.optional);
    const eqDocKeys = eqDefs.map(d => d.key);
    const docLabels = Object.fromEntries(eqDefs.map(d => [d.key, d.label]));
    
    const deficiencies = [];
    eqDocKeys.forEach(key => {
      const status = docs[key];
      const docDeficiencies = docs[`${key}_deficiencies`] || [];
      
      if (!status || status === 'beklemede') {
        deficiencies.push({ document: docLabels[key], doc_key: key, note: 'Belge beklemede' });
      } else if (status === 'eksik') {
        deficiencies.push({ 
          document: docLabels[key], doc_key: key,
          note: docDeficiencies.length > 0 ? docDeficiencies.join(', ') : 'Belge eksik' 
        });
      }
    });
    
    if (deficiencies.length > 0) {
      equipmentDeficiencies.push({
        id: eq.id,
        name: eq.name || '-',
        type: isVehicle ? 'Araç / İş Makinesi' : 'İş Ekipmanı',
        kind: kindOf(eq),
        deficiencies: deficiencies
      });
    } else {
      approvedEquipmentList.push({
        name: eq.name || '-',
        type: isVehicle ? 'Araç / İş Makinesi' : 'İş Ekipmanı',
        kind: kindOf(eq)
      });
    }
  });
  
  return { companyDeficiencies, employeeDeficiencies, approvedEmployeeList, equipmentDeficiencies, approvedEquipmentList };
};
